export default (str) => {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
};



// WEBPACK FOOTER //
// ./src/assets/js/is_json.js